<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script setup>
import { useCssVar, useResizeObserver } from "@vueuse/core";
import { onBeforeUnmount, ref, watch } from "vue";

const props = defineProps({
    cssVar: String,
});

const el = ref(null);
const elementHeight = useCssVar(props.cssVar, ref(document.documentElement));

const { stop } = useResizeObserver(el, (entries) => {
    const entry = entries[0];
    const { blockSize: height } = entry.borderBoxSize[0];
    elementHeight.value = `${height}px`;
});

watch(
    [elementHeight],
    ([height]) => {
        elementHeight.value = height;
    },
    { immediate: true }
);

onBeforeUnmount(() => {
    stop();
});
</script>

<template>
    <div ref="el">
        <slot />
    </div>
</template>
